import { useCallback, useEffect, useState } from "react";
import { GitBranch, AlarmClock, CheckCircle2, ShieldAlert, AlertTriangle, Flame, CalendarClock, ClipboardX } from "lucide-react";
import { StatCard } from "@/components/common/StatCard";
import { api } from "@/lib/api";

export const DRSummary = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  const load = useCallback(async () => { try { setS(await api.list("dr-summary")); } catch { setS(null); } }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const cards = [
    { label: "Decisions Awaiting", value: s?.decisions_awaiting ?? "—", icon: GitBranch, tone: "gold" },
    { label: "Decisions Overdue", value: s?.decisions_overdue ?? "—", icon: AlarmClock, tone: "coral" },
    { label: "Decided This Month", value: s?.decisions_decided_month ?? "—", icon: CheckCircle2, tone: "jungle" },
    { label: "Open Risks", value: s?.open_risks ?? "—", icon: ShieldAlert, tone: "royal" },
    { label: "High-Severity Risks", value: s?.high_risks ?? "—", icon: AlertTriangle, tone: "orange" },
    { label: "Critical Risks", value: s?.critical_risks ?? "—", icon: Flame, tone: "coral" },
    { label: "Risks Overdue Review", value: s?.risks_overdue_review ?? "—", icon: CalendarClock, tone: "orange" },
    { label: "Mitigations Overdue", value: s?.mitigation_overdue ?? "—", icon: ClipboardX, tone: "coral" },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="dr-summary">
      {cards.map((c, i) => <StatCard key={c.label} index={i} testid={`dr-stat-${i}`} {...c} />)}
    </div>
  );
};
